<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        View Logs
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item position-relative">
            Application
        </li>
        <li class="breadcrumb-item position-relative">
            View Logs
        </li>
    </ol>
</div>

<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-content>
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12 mt-custom ml-auto">
                <button *ngIf="showExport" type="button" mat-flat-button class="daxa card-header-menu-btn button-gap"
                    (click)="exportFile()">Export</button>
            </div>
            <div class="col-lg-4 col-md-4"></div>
            <div class="col-lg-4 col-md-4 col-sm-12 mt-custom">
                <div class="d-flex justify-content-end">
                    <button type="button" mat-flat-button class="daxa card-header-menu-btn button-gap"
                        (click)="getData(currentPage)">Refresh</button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-card class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-header>
        <mat-card-title>
            <div class="search-box position-relative">
                <i class="material-symbols-outlined search-icon">search</i>
                <input type="text" class="input-search d-block w-100 border-none outline-0" placeholder="Search here..."
                    [(ngModel)]="searchValue" (keydown.enter)="getData(1)">
                <i *ngIf="searchValue" class="material-symbols-outlined cross-icon" (click)="resetSearch()">
                    close
                </i>
            </div>
        </mat-card-title>

        <mat-card-subtitle>
            <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block filter-badges">
                <mat-card-content class="example-badges">
                    <span class="badge text-outline-daxa" *ngFor="let param of filterParamsArray">{{ param }}</span>
                </mat-card-content>
            </mat-card>
            <!-- <mat-form-field class="button-gap">
                <mat-label>Quick Filters</mat-label>
                <mat-select [(value)]="filterVal" (selectionChange)="onQuickFilterChange($event)">
                    <mat-option value="null">None</mat-option>
                    <mat-option value="24h">24 Hours</mat-option>
                    <mat-option value="7d">7 Days</mat-option>
                    <mat-option value="14d">14 Days</mat-option>
                    <mat-option value="30d">30 Days</mat-option>
                    <mat-option value="12m">Last 12 Months</mat-option>
                    <mat-option value="LY">Last Year</mat-option>
                    <mat-option disabled>----------------------</mat-option>
                    <ng-container *ngFor="let record of quickFilters">
                        <mat-option [value]="record.id">{{record.filter_name}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field> -->
            <button type="button" mat-flat-button class="daxa card-header-menu-btn filters" matTooltip="Filter Data"
                matTooltipPosition="above" (click)="filterData()">Filters</button>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <div class="recent-orders-table">
            <ng-container *ngIf="paginatedData?.totalItems > 0; else noData">
                <div class="table-responsive">
                    <table mat-table [dataSource]="appLogsDataSource">

                        <ng-container matColumnDef="module">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('module')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">Module</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'module' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'module' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'module'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" (contextmenu)="onRightClick($event, element.id)">
                                {{element.module}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="level">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('level')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">Level</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'level' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'level' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'level'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" (contextmenu)="onRightClick($event, element.id)">
                                {{element.level}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('action')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">Action</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'action' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'action' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'action'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" (contextmenu)="onRightClick($event, element.id)">
                                {{element.action}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="message">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('message')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">Message</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'message' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'message' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'message'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" matTooltip="{{element.message}}" (contextmenu)="onRightClick($event, element.id)">
                                {{element.message | truncate:20 }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="created_at">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('created_at')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">Date &amp; Time Created At</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'created_at' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'created_at' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'created_at'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" (contextmenu)="onRightClick($event, element.id)">
                                {{ element.created_at | date:'dd/MM/yyyy hh:mm a' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="user_name">
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="sortable-header" (click)="toggleSort('user_name')"
                                    style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">User</span>
                                    <div class="sort-icons" style="display: flex; align-items: center;">
                                        <mat-icon *ngIf="sortBy === 'user_name' && sortOrder === 'asc'"
                                            class="active-arrow">
                                            arrow_upward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy === 'user_name' && sortOrder === 'desc'"
                                            class="active-arrow">
                                            arrow_downward
                                        </mat-icon>
                                        <mat-icon *ngIf="sortBy !== 'user_name'" class="hover-arrow">
                                            unfold_more
                                        </mat-icon>
                                    </div>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" (contextmenu)="onRightClick($event, element.id)">
                                {{element.user_name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>
                                Action
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-info">
                                    <button type="button" mat-button matTooltip="View Log Details"
                                        matTooltipPosition="above" (click)="getAppLogDetailsDialog(element.id)">
                                        <i class="material-symbols-outlined">
                                            visibility
                                        </i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="onRowDoubleClick(row)">
                        </tr>
                    </table>

                    <div [ngClass]="{ 'dark-context-menu': isDarkTheme }" class="context-menu"
                        [ngStyle]="{ top: contextMenuY + 'px', left: contextMenuX + 'px' }" *ngIf="contextMenuVisible">
                        <button mat-menu-item (click)="getAppLogDetailsDialog(selectedElement)">
                            <i class="material-symbols-outlined">visibility</i> View
                        </button>
                    </div>
                </div>

                <div class="custom-paginator">
                    <button mat-icon-button (click)="goToPage(paginatedData.previousPage)"
                        [disabled]="!paginatedData.canViewPreviousPage">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <span class="paginator-text">
                        Showing {{startItem}}-{{endItem}} of {{totalItems}} items
                        <span *ngIf="totalItems === 0">(No items)</span>
                    </span>

                    <button mat-icon-button (click)="goToPage(paginatedData.nextPage)"
                        [disabled]="!paginatedData.canViewNextPage">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </ng-container>
            <ng-template #noData>
                <hr>
                <div class="no-data-found text-center">
                    <h5>No Data Found</h5>
                </div>
                <hr>
            </ng-template>
        </div>
    </mat-card-content>
</mat-card>

<!-- Loader Overlay -->
<div *ngIf="loading" class="export-overlay">
    <div class="spinner"></div>
</div>